import { render, staticRenderFns } from "./YBAdd.vue?vue&type=template&id=1d7d4909&"
import script from "./YBAdd.vue?vue&type=script&lang=js&"
export * from "./YBAdd.vue?vue&type=script&lang=js&"
import style0 from "./YBAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports